import React from "react";

import { Table } from "semantic-ui-react";

import * as moment from "moment";

const ReimbursementInfoTable = props => {
  const reimbursement = props.reimbursement;
  return (
    <Table definition>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Description</Table.Cell>
          <Table.Cell>{reimbursement.description}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Amount</Table.Cell>
          <Table.Cell>${(+reimbursement.amount).toFixed(2)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Submitter</Table.Cell>
          <Table.Cell>{reimbursement.submitter.name}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Submission date</Table.Cell>
          <Table.Cell>
            {moment(reimbursement.received_at).format("llll")}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Submitted via</Table.Cell>
          <Table.Cell style={{ textTransform: "capitalize" }}>
            {reimbursement.received_via}
          </Table.Cell>
        </Table.Row>
        {reimbursement.status !== "submitted" && (
          <Table.Row>
            <Table.Cell>
              {reimbursement.status === "rejected" ? "Rejector" : "Approver"}
            </Table.Cell>
            <Table.Cell>{reimbursement.reviewer}</Table.Cell>
          </Table.Row>
        )}
        {reimbursement.status === "paid" && (
          <Table.Row>
            <Table.Cell>Pay Approver</Table.Cell>
            <Table.Cell>{reimbursement.payer}</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
};

export default ReimbursementInfoTable;



// WEBPACK FOOTER //
// ./frontend/src/components/ReimbursementInfoTable.js